import React from 'react';
import { Form} from 'reactstrap';
import TableNP from "../../../components/Common/TableContainerNP";

// Formik validation
import { useFormik } from "formik";
import * as Yup from "yup";

import { BaseCustomButton, BaseCustomModal, GradientDecorationLine } from '../../../shared';

export const NotifyAssignmentsModal = ({ props, setShowModal, showModal, modalRespInfo, rowInfo }) => {

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            description: '',
        },
        validationSchema: Yup.object({
            // generalDesc: Yup.string().required("Defina la descripción general"),
        }),
        onSubmit: (values, { resetForm }) => {
            modalRespInfo(values);
            resetForm();
            setShowModal(false);
        }
    });

    //Register Modal
    const { className } = props;

    const toggle = () => {
        setShowModal(false);
    }

    const onClosed = () => {
        // setRowTestIds();
        validation.resetForm();
        setShowModal(false);
    }

    const columns = React.useMemo(
        () => [
            {
                Header: 'Usuario',
                width: '25%',
                Cell: ({ row }) => (
                    <div>
                        <div>{row.original?.user?.name ?? '-'}</div>
                    </div>
                ),
            },
            {
                Header: 'Asunto de Asignaciones',
                width: '20%',
                Cell: ({ row }) => (
                    <div>
                        <div>{row.original?.statusAssignment ?? '-'}</div>
                    </div>
                ),
            },
        ],
        []
    )

    const data = [
        {
            user: 'Daniela Morales Cruz',
            subjectAssignment: 'Validación de muestras', //This information comes from the main table selector
        },
        {
            user: 'Daniela Morales Cruz 2',
            subjectAssignment: 'Validación de muestras', //This information comes from the main table selector
        },
    ]

    const title = (
        <div className='d-flex ms-3 p-0'>
            <label className='m-0 p-0'>
                <h4 className='text-primary m-0 ps-4'>Notificación de asignaciones</h4>
            </label>
        </div>
    );

    const buttons = (
        <div className="page-title-box d-flex justify-content-end">
            <BaseCustomButton
                color='success'
                className='rounded-3 me-2'
                onClick={validation.handleSubmit}
                label='Guardar'
                outline={true}
                icon="mdi mdi-content-save me-1"
            />
            <BaseCustomButton
                color='danger'
                className='rounded-3 me-3'
                onClick={toggle}
                label='Cancelar'
                outline={true}
                icon="mdi mdi-close-circle me-1"
            />
        </div>
    );

    return (
        <>
            <BaseCustomModal
                title={title} 
                isModalOpen={showModal}
                handleCancel={toggle}
                onClosed={onClosed}
                centered
                width="80%"
                className={className}
                footer={buttons} 
            >
                <Form
                    className="form-horizontal mt-3 mb-1"
                    onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                    }}
                >
                    <GradientDecorationLine />

                    <div className="px-4 mx-3">
                        <TableNP isAddTableBorderStrap columns={columns} data={[rowInfo]} />

                        <div className="col-3 col-md-12">
                            <label className="text-primary">Descripción general</label>
                            <textarea
                                name="description"
                                required
                                className="form-control text-primary rounded-3"
                                placeholder="Descripción general"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.description || ""}
                            />
                        </div>
                    </div>

                    <GradientDecorationLine />
                </Form>
            </BaseCustomModal>
        </>
    )
}
